// @flow @jsx h
import { h } from 'preact'
import { PureComponent } from '../../lib/pureComponent'
import { Answers } from './Answers'
import { FactBox } from './FactBox/Fact'
import { Image } from './Image'
import styles from './Question.css'

import type { QuestionProps, UserAnswersProps } from '../types'

type Props = {
  question: QuestionProps,
  userAnswers: UserAnswersProps,
  totalQuestions: number,
  onAnswerClick: () => void
}

export class Question extends PureComponent<Props, {}> {
  state: {
    active: false
  }

  onAnswerClick = (sampleName, questionId, answerId) => {
    this.props.onAnswerClick(sampleName, questionId, answerId)
    this.setState({
      active: true
    })
  }

  render() {
    const { question, userAnswers, totalQuestions } = this.props
    const { questionTitle, questionText, id, picture, answers, factBox } = question
    return (
      <li className={`${styles['personalityquiz-question']}`}>
        <h2 className={`${styles['personalityquiz-question__header']}`}>
          <span className={`${styles['personalityquiz-question__number']}`}>
            {id + 1}/{totalQuestions}
          </span>
          <span className={`${styles['personalityquiz-question__title']}`}>{questionTitle}</span>
        </h2>
        {typeof picture !== 'undefined' && <Image image={picture} />}
        <p dangerouslySetInnerHTML={{ __html: questionText }} />
        <Answers questionId={id} onAnswerClick={this.onAnswerClick} answers={answers} userAnswers={userAnswers} />
        {!!factBox && this.state.active === true ? <FactBox factBox={factBox} /> : null}
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/Question.js